import React, { useEffect, useState } from "react";

import { Alert, Collapse } from "@mui/material";
import { Link } from "react-router-dom";

import { OrgDeletionEventDetail } from "../../types/org-deletion-event-detail";

const OrgDeletionReminder = () => {
  const [showOrgDeletionReminder, setShowOrgDeletionReminder] = useState(false);
  const [deletedOrgRegion, setDeletedOrgRegion] = useState("");
  const [deletedOrgId, setDeletedOrgId] = useState("");

  const reminderDelay = 600000; // 10 minutes measured in milliseconds

  const handleOrgDeletionEvent = ((e: CustomEvent) => {
    const eventDetail = e.detail as OrgDeletionEventDetail;
    if (eventDetail) {
      setTimeout(() => {
        setDeletedOrgId(eventDetail.roleId);
        setDeletedOrgRegion(eventDetail.regionCode);
        setShowOrgDeletionReminder(true);
      }, reminderDelay);
    }
  }) as EventListener;

  const handleOrgDeletionLocalStorageEvent = (e: StorageEvent) => {
    if (
      e.key?.startsWith("delete_") &&
      e.newValue &&
      e.newValue !== e.oldValue &&
      e.newValue !== ""
    ) {
      // key should be in the form "delete_us_role_7a8dcf0d15434e26a0a2138fd460a231"
      const key = e.key;
      const tokens = key.split("_");
      if (tokens[2] === "role") {
        setTimeout(() => {
          setDeletedOrgId(`role_${tokens[3]}`);
          setDeletedOrgRegion(tokens[1]);
          setShowOrgDeletionReminder(true);
        }, reminderDelay);
      }
    }
  };

  useEffect(() => {
    //Register both local storage event listener and custom event listener:
    //- local storage listener - if user used another window/tab to delete an org
    //- custom event listener - if user uses current window/tab to delete an org
    window.addEventListener("org-deletion-event", handleOrgDeletionEvent);
    window.addEventListener("storage", handleOrgDeletionLocalStorageEvent);
    return () => {
      // remove listeners
      window.removeEventListener("org-deletion-event", handleOrgDeletionEvent);
      window.removeEventListener("storage", handleOrgDeletionLocalStorageEvent);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Collapse in={showOrgDeletionReminder} timeout={500}>
      <Alert severity="info" onClose={() => setShowOrgDeletionReminder(false)}>
        Organisation deletion for {deletedOrgId} should be complete —{" "}
        <Link
          to={`/organisation/${deletedOrgRegion}/${deletedOrgId}`}
          onClick={() => setShowOrgDeletionReminder(false)}
        >
          search for the org
        </Link>{" "}
        to confirm it is no longer found.
      </Alert>
    </Collapse>
  );
};

export default OrgDeletionReminder;
